import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const DescriptionDetails = ({ propertyType, wallMaterial, roofMaterial, yearBuilt, hasBodyCorporate, hasSecurityAlarm, onClick, getHref }) => {
    const securityUrl = 'property_security';
    const typeUrl = 'property_type';
    const wallMaterialUrl = 'property_wall_material';
    const roofMaterialUrl = 'property_roof_material';
    const yearBuiltUrl = 'property_year_built';
    return (
        <SnapshotContainer title="Description">
            <SnapshotItem identifier="propertyType" href={getHref(typeUrl)} label={propertyType} onClick={() => onClick(typeUrl)} />
            {wallMaterial && <SnapshotItem identifier="wallMaterial" href={getHref(wallMaterialUrl)} label={`Wall material - ${wallMaterial}`} onClick={() => onClick(wallMaterialUrl)} />}
            {roofMaterial && <SnapshotItem identifier="roofMaterial" href={getHref(roofMaterialUrl)} label={`Roof material - ${roofMaterial}`} onClick={() => onClick(roofMaterialUrl)} />}
            {yearBuilt && <SnapshotItem identifier="yearBuilt" href={getHref(yearBuiltUrl)} label={`Built - ${yearBuilt}`} onClick={() => onClick(yearBuiltUrl)} /> }
            <SnapshotItem identifier="bodyCorporate" href={getHref(securityUrl)} label={hasBodyCorporate} onClick={() => onClick(securityUrl)} />
            <SnapshotItem identifier="securityAlarm" href={getHref(securityUrl)} label={hasSecurityAlarm} onClick={() => onClick(securityUrl)} />
        </SnapshotContainer>
    );
};

DescriptionDetails.propTypes = {
    propertyType: PropTypes.string,
    wallMaterial: PropTypes.string,
    roofMaterial: PropTypes.string,
    yearBuilt: PropTypes.string,
    hasBodyCorporate: PropTypes.string,
    hasSecurityAlarm: PropTypes.string,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { DescriptionDetails };
